import { render, staticRenderFns } from "./Land.vue?vue&type=template&id=192d0541&scoped=true&"
import script from "./Land.vue?vue&type=script&lang=js&"
export * from "./Land.vue?vue&type=script&lang=js&"
import style0 from "./Land.vue?vue&type=style&index=0&id=192d0541&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192d0541",
  null
  
)

export default component.exports